import { render } from "./ServiceForm.vue?vue&type=template&id=c435ba9a&scoped=true"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"

import "./ServiceForm.vue?vue&type=style&index=0&id=c435ba9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c435ba9a"]])

export default __exports__